import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AdminLayout from "@/components/AdminLayout";
import { ShieldCheck, Mail, Download } from "lucide-react";

export default function CasaMadreCRM() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/casa-madre/customers-conto-terzi").then((r) => setRows(r.data));
  }, []);

  const exportCsv = () => {
    const headers = ["Email", "Nome", "Telefono", "Ordini", "Totale speso", "Ultimo ordine", "Rivenditori"];
    const csv = [headers.join(",")].concat(
      rows.map((r) => [
        r.email, `"${r.name || ""}"`, r.phone || "",
        r.orders_count, r.total_spent, r.last_order || "",
        `"${(r.rivenditori || []).join("; ")}"`
      ].join(","))
    ).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `crm_conto_terzi_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
  };

  return (
    <AdminLayout>
      <div className="p-8 lg:p-10" data-testid="cm-crm-page">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="overline text-brand mb-2 flex items-center gap-2">
              <ShieldCheck className="w-3 h-3" /> Casa Madre · Conto Terzi GDPR
            </div>
            <h1 className="font-heading font-bold text-4xl tracking-tight">CRM clienti finali</h1>
            <p className="text-muted-foreground mt-2 text-sm max-w-2xl">
              Clienti dei tuoi rivenditori che hanno dato il <b>secondo consenso GDPR</b>: puoi contattarli per
              attività di marketing conto terzi. Tutti gli altri sono visibili solo ai rispettivi rivenditori.
            </p>
          </div>
          {rows.length > 0 && (
            <button data-testid="crm-export-btn" onClick={exportCsv}
              className="inline-flex items-center gap-2 px-4 h-10 rounded-sm border border-border text-sm hover:bg-accent">
              <Download className="w-4 h-4" /> Export CSV
            </button>
          )}
        </div>

        <div className="bg-white border border-border rounded-sm overflow-hidden">
          {rows.length === 0 ? (
            <div className="text-center py-16">
              <Mail className="w-10 h-10 text-muted-foreground mx-auto mb-3" strokeWidth={1.5} />
              <p className="text-sm text-muted-foreground">Nessun cliente ha ancora autorizzato la trasmissione conto terzi.</p>
              <p className="text-xs text-muted-foreground mt-1">I clienti devono spuntare il secondo consenso al checkout dei tuoi rivenditori.</p>
            </div>
          ) : (
            <table className="w-full">
              <thead>
                <tr className="bg-[#FAFAFA] border-b border-border">
                  <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Email</th>
                  <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Nome</th>
                  <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Telefono</th>
                  <th className="text-center px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Ordini</th>
                  <th className="text-right px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Speso</th>
                  <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Rivenditori</th>
                  <th className="text-left px-5 py-3 text-[11px] uppercase tracking-wider text-muted-foreground">Ultimo ordine</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.email} className="border-b border-border last:border-0 hover:bg-accent/20" data-testid={`crm-row-${r.email}`}>
                    <td className="px-5 py-3 text-sm font-medium">{r.email}</td>
                    <td className="px-5 py-3 text-sm">{r.name || "—"}</td>
                    <td className="px-5 py-3 text-sm">{r.phone || "—"}</td>
                    <td className="px-5 py-3 text-center font-medium">{r.orders_count}</td>
                    <td className="px-5 py-3 text-right font-medium">€ {r.total_spent}</td>
                    <td className="px-5 py-3 text-xs text-muted-foreground">{(r.rivenditori || []).join(", ")}</td>
                    <td className="px-5 py-3 text-xs text-muted-foreground">{r.last_order ? new Date(r.last_order).toLocaleDateString() : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
